import useAxios from 'axios-hooks'
import React, { createContext } from 'react'
import { useSearchParamsHandler } from '~/contexts/FilterContext'

const IntegrationsContext = createContext()

const FILTER = {
  pending: 'PENDING',
  divergence: 'DIVERGENT',
  linked: 'LINKED',
}

const IntegrationsProvider = ({ children }) => {
  const [
    { data: locationsData, loading: filterLoading },
    refetchLocations,
  ] = useAxios({
    url: `/nissei/locations/select`,
    method: 'GET',
  })
  const locations = locationsData?.locations

  const { query, setQueries } = useSearchParamsHandler()
  const currentTab = query['integration-tab']
  const currentPage = query['integration-page']
  const currentLimit = query['integration-limit']

  const [{ data, loading: dataLoading }, refetch] = useAxios(
    {
      url: `/nissei/locations`,
      method: 'GET',
      params: {
        page: currentPage,
        limit: currentLimit,
        filter: FILTER[currentTab],
      },
    },
    {
      useCache: false,
    }
  )

  const [, postNissei] = useAxios(`/nissei/link`, {
    manual: true,
    method: 'POST',
  })

  const setIntegration = async (linkId, nisseiId, locationId) => {
    if (!locationId) {
      await postNissei({
        method: 'POST',
        url: `/nissei/${linkId}/unlink`,
      })
    } else {
      await postNissei({
        url: `/nissei/link`,
        method: 'POST',
        data: {
          googleLocation: locationId,
          nisseiLocation: nisseiId,
        },
      })
    }

    await refetch()
    await refetchLocations()
  }
  function handleTab(id) {
    if (id === currentTab) return
    setQueries({
      'integration-tab': id,
      'integration-page': 1,
      'integration-limit': query['integration-limit'],
    })
  }

  React.useEffect(() => {
    refetch()
  }, [currentTab])
  const isLoading = filterLoading || dataLoading

  const count = {
    pending: data?.metadata.pending,
    divergence: data?.metadata.divergent,
  }
  return (
    <IntegrationsContext.Provider
      value={{
        currentTab,
        currentLimit,
        currentPage,
        handleTab,
        isLoading,
        locations,
        integrations: data?.locations,
        setIntegration,
        count,
        totalPages: data?.metadata['total-pages'] || 0,
        totalItems: data?.metadata['total-items'] || 0,
        noContent: !isLoading && data?.locations.length === 0,
      }}
    >
      {children}
    </IntegrationsContext.Provider>
  )
}

const useIntegrations = () => {
  const context = React.useContext(IntegrationsContext)
  if (!context) {
    throw new Error(
      'useIntegrations must be used within an IntegrationsProvider'
    )
  }
  const {
    currentTab,
    currentLimit,
    currentPage,
    handleTab,
    isLoading,
    locations,
    integrations,
    setIntegration,
    count,
    totalPages,
    totalItems,
    noContent,
  } = context
  return {
    currentTab,
    currentLimit,
    currentPage,
    handleTab,
    isLoading,
    locations,
    integrations,
    setIntegration,
    count,
    totalPages,
    totalItems,
    noContent,
  }
}

export { useIntegrations }

export { IntegrationsProvider }
